import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.HISTORICO.BUSCAR_HISTORICOS]({ state }, idItemAta) {
		const { paginacao } = state
		const { data } = await api.alterarFornecedor.buscarHistoricoAlterarFornecedor(idItemAta, paginacao)
		return data
	},
}
